export const boolFormat = (
  value: boolean,
  trueText: string,
  falseText: string
): string => {
  return value ? trueText || "Yes" : falseText || "No";
};
